import { ErrorMessage as HookFormErrorMessage } from "@hookform/error-message"
import { useTranslation } from "react-i18next"
import { FlatNamespace, ParseKeys } from "i18next"
import { useCallback } from "react"

interface TranslatedErrorMessageProps extends React.ComponentProps<
  typeof HookFormErrorMessage
> {
  namespaces: FlatNamespace | FlatNamespace[]
}

export function ErrorMessage({
  namespaces,
  render,
  ...props
}: TranslatedErrorMessageProps) {
  const { t } = useTranslation(namespaces)

  const translatedRenderProp = useCallback(
    // A key resolved across every namespace types as the union of what each
    // holds under it; an error message is always a leaf string.
    ({ message }: { message: string }) =>
      render &&
      render({
        message: t(message as ParseKeys<typeof namespaces>) as string,
      }),
    [render, t],
  )
  return <HookFormErrorMessage render={translatedRenderProp} {...props} />
}
